(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name orders.factory:DepositOrderTypesService
     *
     * @description
     *
     */
    angular
        .module('orders')
        .factory('DepositOrderTypesService', DepositOrderTypesService);

    function DepositOrderTypesService(EndpointsService, $q, $http) {
        var DepositOrderTypesServiceBase = {};

        DepositOrderTypesServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.depositOrderTypes, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        DepositOrderTypesServiceBase.getAll = function (params) {
            var predefinedParams = {
                page: 0,
                pageSize: 1000
            };
            var extended = _.extend(predefinedParams, params);
            return DepositOrderTypesServiceBase.getPage(extended);
        };

        DepositOrderTypesServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.depositOrderTypes_id.replace('{id}', id))
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        
        
        
        


        return DepositOrderTypesServiceBase;
    }
}());